/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum ActivityTypeEnum {
  LAST_PLAY_TYPE = 'LAST_PLAY_TYPE',
  NEW_COURSE_ASSIGNED_TYPE = 'NEW_COURSE_ASSIGNED_TYPE',
}

export enum CertificateTypeEnum {
  CERTIFICATE_TYPE_ACADEMY = 'CERTIFICATE_TYPE_ACADEMY',
  CERTIFICATE_TYPE_CAREER = 'CERTIFICATE_TYPE_CAREER',
  CERTIFICATE_TYPE_CERTIFICATION = 'CERTIFICATE_TYPE_CERTIFICATION',
  CERTIFICATE_TYPE_COURSE = 'CERTIFICATE_TYPE_COURSE',
  CERTIFICATE_TYPE_TRACK = 'CERTIFICATE_TYPE_TRACK',
  PARTICIPATION_CERTIFICATE_TYPE_COURSE = 'PARTICIPATION_CERTIFICATE_TYPE_COURSE',
  PARTICIPATION_CERTIFICATE_TYPE_MINEDU = 'PARTICIPATION_CERTIFICATE_TYPE_MINEDU',
  PARTICIPATION_CERTIFICATE_TYPE_SIXTH_ANNIVERSARY = 'PARTICIPATION_CERTIFICATE_TYPE_SIXTH_ANNIVERSARY',
  PARTICIPATION_CERTIFICATE_TYPE_WORKSHOP = 'PARTICIPATION_CERTIFICATE_TYPE_WORKSHOP',
}

export enum CertificateTypeFilterEnum {
  CERTIFICATE_TYPE_ACADEMY = 'CERTIFICATE_TYPE_ACADEMY',
  CERTIFICATE_TYPE_CAREER = 'CERTIFICATE_TYPE_CAREER',
  CERTIFICATE_TYPE_CERTIFICATION = 'CERTIFICATE_TYPE_CERTIFICATION',
  CERTIFICATE_TYPE_COURSE = 'CERTIFICATE_TYPE_COURSE',
  CERTIFICATE_TYPE_PARTICIPATION_CERTIFICATE = 'CERTIFICATE_TYPE_PARTICIPATION_CERTIFICATE',
  CERTIFICATE_TYPE_TRACK = 'CERTIFICATE_TYPE_TRACK',
}

export enum ContentOrderByEnum {
  CREATED_AT = 'CREATED_AT',
  TITLE = 'TITLE',
}

export enum ContentType {
  CONTENT_TYPE_COURSE = 'CONTENT_TYPE_COURSE',
  CONTENT_TYPE_ELEVATE_COURSE = 'CONTENT_TYPE_ELEVATE_COURSE',
  CONTENT_TYPE_FILE = 'CONTENT_TYPE_FILE',
  CONTENT_TYPE_PATH = 'CONTENT_TYPE_PATH',
  CONTENT_TYPE_THIRD_PARTY_COURSE = 'CONTENT_TYPE_THIRD_PARTY_COURSE',
  CONTENT_TYPE_TRACK = 'CONTENT_TYPE_TRACK',
}

export enum CourseTypeContentEnum {
  COURSE_TYPE_CREHANA = 'COURSE_TYPE_CREHANA',
  COURSE_TYPE_ELEVATE = 'COURSE_TYPE_ELEVATE',
  COURSE_TYPE_EXTERNAL = 'COURSE_TYPE_EXTERNAL',
}

export enum CourseTypeEnum {
  B2B = 'B2B',
  B2B_CLASSROOMS = 'B2B_CLASSROOMS',
  CREHANA_COURSE_TYPE = 'CREHANA_COURSE_TYPE',
  DEGREE = 'DEGREE',
  EXTERNAL_COURSE_TYPE = 'EXTERNAL_COURSE_TYPE',
  FREE = 'FREE',
  FREEMIUM = 'FREEMIUM',
  HIDDEN = 'HIDDEN',
  MEMBERSHIP = 'MEMBERSHIP',
  OWN_COURSE_TYPE = 'OWN_COURSE_TYPE',
  PAID = 'PAID',
  PARTNER = 'PARTNER',
  ROCKSTAR = 'ROCKSTAR',
  TEMPORAL_ACCESS = 'TEMPORAL_ACCESS',
}

export enum DocumentActionEnum {
  BOTH = 'BOTH',
  DOWNLOAD = 'DOWNLOAD',
  PREVIEW = 'PREVIEW',
}

export enum DocumentFileFormatEnum {
  DOCUMENT_DOCX = 'DOCUMENT_DOCX',
  DOCUMENT_JPG = 'DOCUMENT_JPG',
  DOCUMENT_PDF = 'DOCUMENT_PDF',
  DOCUMENT_PNG = 'DOCUMENT_PNG',
  DOCUMENT_PPT = 'DOCUMENT_PPT',
  DOCUMENT_TXT = 'DOCUMENT_TXT',
  DOCUMENT_XLSX = 'DOCUMENT_XLSX',
  DOCUMENT_ZIP = 'DOCUMENT_ZIP',
}

export enum EnrollmentCourseProgressState {
  CERTIFIED = 'CERTIFIED',
  COMPLETED = 'COMPLETED',
  INITIAL = 'INITIAL',
  IN_PROGRESS = 'IN_PROGRESS',
}

export enum EnrollmentOrderByEnum {
  COURSE_TITLE = 'COURSE_TITLE',
  ENROLLMENT_AT = 'ENROLLMENT_AT',
}

export enum OrderDirectionEnum {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum QuizRetryTimeEnum {
  RETRY_TIME_120_MIN = 'RETRY_TIME_120_MIN',
  RETRY_TIME_180_MIN = 'RETRY_TIME_180_MIN',
  RETRY_TIME_240_MIN = 'RETRY_TIME_240_MIN',
  RETRY_TIME_60_MIN = 'RETRY_TIME_60_MIN',
  RETRY_WITHOUT_TIME = 'RETRY_WITHOUT_TIME',
}

export enum QuizTimeLimitEnum {
  TIME_120_MIN = 'TIME_120_MIN',
  TIME_30_MIN = 'TIME_30_MIN',
  TIME_45_MIN = 'TIME_45_MIN',
  TIME_60_MIN = 'TIME_60_MIN',
  TIME_WITHOUT = 'TIME_WITHOUT',
}

export enum QuizTypeEnum {
  TYPE_CUMULATIVE = 'TYPE_CUMULATIVE',
  TYPE_FORMATIVE = 'TYPE_FORMATIVE',
}

export enum RoleEnum {
  ADMIN = 'ADMIN',
  EMPLOYEE = 'EMPLOYEE',
  MANAGER = 'MANAGER',
  MULT_ADMIN = 'MULT_ADMIN',
  READER = 'READER',
  ROOT = 'ROOT',
}

export enum SocialHubNewsStatusEnum {
  SOCIAL_HUB_NEWS_STATUS_COMPLETED = 'SOCIAL_HUB_NEWS_STATUS_COMPLETED',
  SOCIAL_HUB_NEWS_STATUS_PENDING = 'SOCIAL_HUB_NEWS_STATUS_PENDING',
}

export enum StatusProjectEnum {
  CERTIFIED = 'CERTIFIED',
  DRAFT = 'DRAFT',
  FINISHED = 'FINISHED',
  OBSERVED = 'OBSERVED',
  PUBLISHED = 'PUBLISHED',
  RESOLVED = 'RESOLVED',
}

export enum StudioCourseConfigStateEnum {
  HIDDEN = 'HIDDEN',
}

export enum TaskTimeLimitCompleteEnum {
  DAYS_AFTER_ASSIGNMENT = 'DAYS_AFTER_ASSIGNMENT',
  NO_TIME_LIMIT = 'NO_TIME_LIMIT',
  TASK_IS_ASSIGNED = 'TASK_IS_ASSIGNED',
}

export enum UserTeamOrderByEnum {
  ORGANIZATION_TEAM_END_DATE = 'ORGANIZATION_TEAM_END_DATE',
  USER_TEAM_EXPIRATION_DATE = 'USER_TEAM_EXPIRATION_DATE',
}

export enum UserTeamSearchFilterEnum {
  TEAM_SEARCH_FILTER_ALL = 'TEAM_SEARCH_FILTER_ALL',
  TEAM_SEARCH_FILTER_COMPLETED = 'TEAM_SEARCH_FILTER_COMPLETED',
  TEAM_SEARCH_FILTER_CURRENT = 'TEAM_SEARCH_FILTER_CURRENT',
  TEAM_SEARCH_FILTER_DISABLED = 'TEAM_SEARCH_FILTER_DISABLED',
  TEAM_SEARCH_FILTER_EXPIRED = 'TEAM_SEARCH_FILTER_EXPIRED',
  TEAM_SEARCH_FILTER_NOT_COMPLETED = 'TEAM_SEARCH_FILTER_NOT_COMPLETED',
}

export enum WorkFlowTaskOrderByEnum {
  CREATED_AT = 'CREATED_AT',
  LIMIT_DATE = 'LIMIT_DATE',
  NAME = 'NAME',
}

export enum WorkFlowTaskTypeEnum {
  COMPLETE_PROFILE = 'COMPLETE_PROFILE',
  CUSTOM_TASK = 'CUSTOM_TASK',
  DOCUMENTS = 'DOCUMENTS',
}

export enum WorkFlowUserStatusEnum {
  COMPLETED = 'COMPLETED',
  PENDING = 'PENDING',
  READY_TO_SIGN = 'READY_TO_SIGN',
  SIGNED = 'SIGNED',
}

export interface CompleteUserNewsInput {
  centralized_organization_id: number;
  user_news_id: number;
}

export interface ContentInputOrderBy {
  field: ContentOrderByEnum;
  direction: OrderDirectionEnum;
}

export interface CourseRestrictionInput {
  organization_id?: number | null;
  course_id: string;
}

export interface EnrollmentFiltersInput {
  progress_state?: EnrollmentCourseProgressState | null;
  is_hidden?: boolean | null;
  assigned_courses?: boolean | null;
  course_title?: string | null;
  course_is_mandatory?: boolean | null;
}

export interface EnrollmentFiltersInputV2 {
  course_title?: string | null;
  filter_ids: string[];
}

export interface EnrollmentInputOrderBy {
  field: EnrollmentOrderByEnum;
  direction: OrderDirectionEnum;
}

export interface GetCertificatesInput {
  certificate_type_filter_enum?: CertificateTypeFilterEnum | null;
  first?: number | null;
  page?: number | null;
}

export interface GetQuizByClassInput {
  organization_id?: number | null;
  video_lecture_id: string;
}

export interface GetTasksByUserInput {
  first?: number | null;
  after?: string | null;
  centralized_organization_id: string;
  user_id: string;
  search_key?: string | null;
  order_by?: WorkFlowTaskOrderByInput | null;
  status?: WorkFlowUserStatusEnum | null;
  task_type?: WorkFlowTaskTypeEnum | null;
  assigned_user?: number | null;
}

export interface GetUserProfileSocialHubNewsInput {
  first?: number | null;
  after?: string | null;
  centralized_organization_id: number;
}

export interface GetUsersCourseInput {
  position_ids?: number[] | null;
  group_ids?: number[] | null;
  course_id: number;
  search?: SearchInput | null;
  pagination: PaginationInput;
}

export interface KnowledgehubContentByCollaboratorInput {
  content_types?: ContentType[] | null;
  order_by?: ContentInputOrderBy[] | null;
  is_new_content?: boolean | null;
  before?: string | null;
  after?: string | null;
  first?: number | null;
  last?: number | null;
}

export interface MyAssignedCoursesInput {
  search?: SearchInput | null;
  pagination: PaginationInput;
}

export interface MyAssignedPathsInput {
  search?: SearchInput | null;
  pagination: PaginationInput;
}

export interface PaginationInput {
  last?: number | null;
  before?: string | null;
  after?: string | null;
  first?: number | null;
}

export interface SearchInput {
  query?: string | null;
}

export interface TalentDashboardCollaboratorTimelineInput {
  user_id?: number | null;
  user_email?: string | null;
  month_number: number;
  year_number?: number | null;
  company_id?: number | null;
}

export interface TalentDashboardCollaboratorTodoListInput {
  user_id?: number | null;
  user_email?: string | null;
  company_id?: number | null;
}

export interface TalentEmployeeInput {
  after?: string | null;
  first?: number | null;
  company_id: number;
  job_names?: string[] | null;
  division_ids?: number[] | null;
  subsidiary_ids?: number[] | null;
  level_ids?: number[] | null;
  person_name?: string | null;
  person_email?: string | null;
  leader_id?: number | null;
  employee_ids?: number[] | null;
}

export interface UserOrganizationTeamInput {
  organization_id?: number | null;
  organization_team_id: number;
}

export interface UserTeamInputOrderBy {
  field: UserTeamOrderByEnum;
  direction: OrderDirectionEnum;
}

export interface UserTeamRewardInput {
  organization_id?: number | null;
  organization_team_id: number;
}

export interface WorkFlowTaskOrderByInput {
  column: WorkFlowTaskOrderByEnum;
  direction: OrderDirectionEnum;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
